export default {
	"foreuserOrganization": {
		"addUser": "e新增人员",
		"addRoles": "e角色添加"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/foreuserOrganization/foreuserOrganization.js